import { SVGProps, Ref, forwardRef } from 'react';

export const LockOpenedOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M6.699 8.331v3.333h-1.4V8.33z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.967 2.554c.307.553.515 1.28.62 2.112h1.409C15.723 2.17 14.619 0 12.066 0 9.72 0 8.597 1.838 8.22 4.075a26 26 0 0 0-2.222-.076C.75 3.999 0 4.749 0 9.998s.75 5.998 5.999 5.998 5.998-.75 5.998-5.998c0-3.68-.368-5.148-2.396-5.697.115-.68.304-1.277.565-1.747.416-.748.983-1.154 1.9-1.154.919 0 1.486.406 1.901 1.154M1.575 7.105c-.127.671-.175 1.591-.175 2.893s.048 2.22.175 2.892c.124.657.298.937.446 1.085s.427.322 1.085.446c.671.127 1.591.175 2.893.175s2.22-.049 2.892-.175c.658-.124.937-.298 1.085-.446s.322-.428.446-1.085c.127-.671.175-1.591.175-2.892 0-1.302-.048-2.222-.175-2.893-.124-.657-.298-.937-.446-1.085s-.427-.322-1.085-.446c-.671-.126-1.591-.175-2.892-.175-1.302 0-2.222.049-2.893.175-.658.124-.937.298-1.085.446s-.322.428-.446 1.085"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
LockOpenedOutlinedSize16Glyph.displayName = 'LockOpenedOutlinedSize16Glyph';
